/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */

import { Box } from '@mui/material';

import { Folder } from '../../../../services/requests/pastas/types';

import { Archives } from '../Archives';
import { Container } from './styles';

export interface FilesListProps {
  files: Folder[] | undefined;
  setFiles: (files: any[]) => void;
  loading: boolean;
  onLoad: any;
  handleOpenFileViewer: any;
  isAutomatic?: boolean;
  isInFolder?: boolean;
}

export const FilesList = ({
  files,
  loading,
  onLoad,
  setFiles,
  handleOpenFileViewer,
  isAutomatic = false,
  isInFolder = false,
}: FilesListProps) => {
  return (
    <>
      {files && files?.length > 0 ? (
        <Container>
          <Archives
            files={files}
            setFiles={setFiles}
            onLoad={onLoad}
            handleOpenFileViewer={handleOpenFileViewer}
            isAutomatic={isAutomatic}
            isInFolder={isInFolder}
          />
        </Container>
      ) : (
        <Box marginTop="20px">
          <span>No momento você não possui pastas.</span>
        </Box>
      )}
    </>
  );
};
